import axios from 'axios'

import type { ContactSchemaType } from '~/schemas'

export async function sendEmail(data: ContactSchemaType, turnstileToken: string) {
  return await axios.post('/api/send-email', {
    name: data.name,
    from: data.from,
    subject: data.subject,
    text: data.text,
    turnstileToken,
  })
}
